import { FC } from 'react'
import { Badge } from '@cloudscape-design/components'

import { summarizeUserAccessForList } from '../../../helper/permissionRoles'

type AccessSummaryCellProps = {
	permissions: string[]
}

const badgeColor = (kind: ReturnType<typeof summarizeUserAccessForList>['kind']) => {
	if (kind === 'super-admin' || kind === 'raci') {
		return 'green'
	}
	return 'blue'
}

const AccessSummaryCell: FC<AccessSummaryCellProps> = ({ permissions }) => {
	const summary = summarizeUserAccessForList(permissions)

	return (
		<div
			style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: '6px',
				alignItems: 'center'
			}}
		>
			{summary.items.map((item) => (
				<Badge key={item} color={badgeColor(summary.kind)}>
					{item}
				</Badge>
			))}
			{summary.extraCount > 0 && (
				<Badge color="grey">+{summary.extraCount} more</Badge>
			)}
		</div>
	)
}

export default AccessSummaryCell
